import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = { class: "d-flex flex-wrap ga-1 mb-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "pa-2" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-center my-3"
}

import { compartirSistemaAleman } from "@/composables/useSistemaAleman";
import { compartirTorneoCerrado } from "@/composables/useTorneoCerrado";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { Torneo, TorneoGestionInfoDTO } from "@/interfaces/Torneo";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import {
  getInfoTorneoCreado,
  getPartidasTorneo,
  getTorneo,
  guardarResultados,
  isSaveTournament,
} from "@/services/TorneosService";
import {
  eliminarJornadasLigaAsync,
  generarLigaAsync,
} from "@/services/LigaService";
import {
  calendarioLiga,
  generarClasificacionLiga,
  partidaJugada,
} from "@/utils/clasificacionLiga";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import CardGestionTorneo from "@/components/GestionTorneos/CardGestionTorneo.vue";
import TabMostrarListas from "@/components/GestionTorneos/TabMostrarListas.vue";
import TablaInscritosLiga from "@/components/GestionTorneos/Liga/TablaInscritosLiga.vue";
import TabJornadasLiga from "@/components/GestionTorneos/Liga/TabJornadasLiga.vue";
import TablaClasificacionLiga from "@/components/GestionTorneos/Liga/TablaClasificacionLiga.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleTorneoGestionLigaView',
  setup(__props) {

const route = useRoute();
const idTorneo = Number(route.params.idTorneo);

const tab = ref("gestion");
const isLoading = ref(true);
const torneo = ref<Torneo>();
// Con el sistema alemán, las partidas enseñan también los puntos que dan
compartirSistemaAleman(() => torneo.value?.classificationType);
const torneoGestion = ref<TorneoGestionInfoDTO>();
const partidas = ref<PartidaTorneoDTO[]>([]);
// Con los resultados guardados ya no se retira a nadie ni se vuelve a cerrar
const ligaCerrada = ref(false);
// Cerrado, las tarjetas y tablas no enseñan lo que ya no se puede cambiar
compartirTorneoCerrado(ligaCerrada);

const ligaGenerada = computed(() => partidas.value.length > 0);
const cuenta = (n: number, singular: string, plural: string) =>
  `${n} ${n === 1 ? singular : plural}`;
const numeroJornadas = computed(() =>
  partidas.value.reduce((max, p) => Math.max(max, p.numeroRonda), 0)
);
const jugadas = computed(() => partidas.value.filter(partidaJugada).length);
const jugadoresActivos = computed(
  () =>
    torneoGestion.value?.inscripciones.filter(
      i => i.estadoInscripcion !== "RETIRADO"
    ).length ?? 0
);
const calendario = computed(() =>
  calendarioLiga(jugadoresActivos.value, torneo.value?.idaYVuelta ?? false)
);
const clasificacion = computed(() =>
  generarClasificacionLiga(
    partidas.value,
    torneoGestion.value?.inscripciones ?? [],
    torneo.value?.classificationType
  )
);

async function cargar() {
  try {
    const [respTorneo, respGestion, respPartidas, respCerrada] =
      await Promise.all([
        getTorneo(idTorneo),
        getInfoTorneoCreado(idTorneo),
        getPartidasTorneo(idTorneo),
        isSaveTournament(idTorneo),
      ]);
    torneo.value = respTorneo.data;
    torneoGestion.value = respGestion.data;
    partidas.value = respPartidas.data;
    ligaCerrada.value = respCerrada.data === true;
  } catch (error) {
    console.error("Error al cargar la liga:", error);
  } finally {
    isLoading.value = false;
  }
}

onMounted(cargar);

async function actualizarPartida(actualizada: PartidaTorneoDTO) {
  const i = partidas.value.findIndex(
    p => p.idPartidaTorneo === actualizada.idPartidaTorneo
  );
  if (i !== -1) partidas.value[i] = { ...partidas.value[i], ...actualizada };
  // Con ELO, la variación la calcula el servidor al guardar: se recargan para verla
  if (torneo.value?.cuentaElo) {
    try {
      partidas.value = (await getPartidasTorneo(idTorneo)).data;
    } catch (error) {
      console.error("Error al recargar las partidas:", error);
    }
  }
}

// Confirmaciones
const showConfirmar = ref(false);
const confirmar = ref<{
  titulo: string;
  texto: string;
  color: string;
  accion: () => Promise<void>;
}>({ titulo: "", texto: "", color: "primary", accion: () => Promise.resolve() });

function pedir(
  titulo: string,
  texto: string,
  color: string,
  accion: () => Promise<void>
) {
  confirmar.value = { titulo, texto, color, accion };
  showConfirmar.value = true;
}

async function ejecutarConfirmado() {
  showConfirmar.value = false;
  await confirmar.value.accion();
}

const isGuardando = ref(false);
const showSuccess = ref(false);
const showError = ref(false);
const mensaje = ref("");

async function ejecutar(
  accion: () => Promise<unknown>,
  exito: string,
  fallo: string
) {
  isGuardando.value = true;
  try {
    await accion();
    mensaje.value = exito;
    showSuccess.value = true;
    await cargar();
  } catch (error) {
    mensaje.value = mensajeDelBack(error, fallo);
    showError.value = true;
  } finally {
    isGuardando.value = false;
  }
}

function pedirGenerar() {
  const { jornadas, partidas: total } = calendario.value;
  pedir(
    "¿Generar la liga?",
    `Con ${jugadoresActivos.value} jugadores se crean ${jornadas} jornadas y ${total} partidas. Se cierran las inscripciones y cada jugador recibe un correo.`,
    "primary",
    () =>
      ejecutar(
        () => generarLigaAsync(idTorneo),
        "Liga generada.",
        "No se ha podido generar la liga."
      )
  );
}

function pedirEliminar() {
  pedir(
    "¿Eliminar las jornadas?",
    "Se borran todas las partidas para poder volver a generar la liga. Solo se puede mientras no se haya jugado ninguna.",
    "error",
    () =>
      ejecutar(
        () => eliminarJornadasLigaAsync(idTorneo),
        "Jornadas eliminadas.",
        "No se han podido eliminar las jornadas."
      )
  );
}

function pedirGuardar() {
  const pendientes = partidas.value.length - jugadas.value;
  pedir(
    "¿Cerrar la liga y guardar los resultados?",
    `Se guardan las posiciones de la clasificación actual.${
      pendientes > 0
        ? ` ${pendientes === 1 ? "Queda 1 partida sin jugar, que no cuenta." : `Quedan ${pendientes} partidas sin jugar, que no cuentan.`}`
        : ""
    } Después ya no se puede retirar a nadie ni eliminar las jornadas.`,
    "primary",
    () =>
      ejecutar(
        () =>
          guardarResultados({
            ganadoresDTO: clasificacion.value.map(fila => ({
              idUsuario: fila.idUsuario,
              idTorneo,
              resultado: fila.posicion,
            })),
            generarRondaDTO: {
              emparejamientos: [],
              luzVsOscCheck: false,
              mismaComunidadCheck: false,
              retosCheck: false,
              esEloCheck: false,
              opcionImpares: null,
              idTorneo,
              idRonda: numeroJornadas.value,
              isTorneoNarsil: false,
            },
          }),
        "Resultados guardados.",
        "No se han podido guardar los resultados."
      )
  );
}

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-2 pa-sm-4" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingGandalf)
          ]))
        : (torneoGestion.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              class: "mx-auto",
              "max-width": "800"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
                  "show-arrows": "",
                  grow: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: "gestion" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Gestión")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "jornadas" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Jornadas")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "clasificacion" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Clasificación")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "listas" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Listas")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_tabs_window, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tabs_window_item, { value: "gestion" }, {
                      default: _withCtx(() => [
                        _createVNode(CardGestionTorneo, { torneo: torneoGestion.value }, null, 8, ["torneo"]),
                        _createVNode(_component_v_card, { class: "mb-4 text-left" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Liga")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                  _createVNode(_component_v_chip, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(torneo.value?.idaYVuelta ? "Ida y vuelta" : "Solo ida"), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_chip, {
                                    size: "small",
                                    color: torneo.value?.cuentaElo ? 'primary' : undefined
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(torneo.value?.cuentaElo
                      ? "Cuenta para el ELO"
                      : "No cuenta para el ELO"), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color"]),
                                  (ligaCerrada.value)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        size: "small",
                                        color: "success"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Cerrada ")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                (!ligaGenerada.value)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                      _createTextVNode(" Con " + _toDisplayString(cuenta(jugadoresActivos.value, "jugador", "jugadores")) + " salen ", 1),
                                      _createElementVNode("strong", null, _toDisplayString(cuenta(calendario.value.jornadas, "jornada", "jornadas")), 1),
                                      _createTextVNode(" y " + _toDisplayString(cuenta(calendario.value.partidas, "partida", "partidas")) + ". Al generarla se cierran las inscripciones y cada jugador recibe un correo. ", 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(cuenta(numeroJornadas.value, "jornada", "jornadas")) + " · " + _toDisplayString(cuenta(partidas.value.length, "partida", "partidas")) + " · " + _toDisplayString(cuenta(jugadas.value, "jugada", "jugadas")), 1))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_actions, { class: "flex-wrap ga-2 justify-center" }, {
                              default: _withCtx(() => [
                                (!ligaGenerada.value)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      color: "primary",
                                      variant: "tonal",
                                      disabled: jugadoresActivos.value < 3,
                                      onClick: pedirGenerar
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Generar liga ")
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]))
                                  : _createCommentVNode("", true),
                                (ligaGenerada.value && jugadas.value === 0)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      color: "error",
                                      variant: "tonal",
                                      onClick: pedirEliminar
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Eliminar jornadas ")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            (!ligaGenerada.value && jugadoresActivos.value < 3)
                              ? (_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 0,
                                  class: "pt-0 text-caption"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Hacen falta al menos 3 jugadores para generar la liga. ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(TablaInscritosLiga, {
                          torneo: torneoGestion.value,
                          ligaGenerada: ligaGenerada.value,
                          ligaCerrada: ligaCerrada.value,
                          onActualizado: cargar
                        }, null, 8, ["torneo", "ligaGenerada", "ligaCerrada"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tabs_window_item, { value: "jornadas" }, {
                      default: _withCtx(() => [
                        (!ligaGenerada.value)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: "info",
                              variant: "tonal",
                              class: "ma-4"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" La liga aún no está generada. Genérala desde la pestaña Gestión cuando cierres las inscripciones. ")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(TabJornadasLiga, {
                              key: 1,
                              partidas: partidas.value,
                              jornadas: numeroJornadas.value,
                              editable: true,
                              onPartidaActualizada: actualizarPartida
                            }, null, 8, ["partidas", "jornadas"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tabs_window_item, { value: "clasificacion" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (clasificacion.value.length === 0)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                type: "info",
                                variant: "tonal",
                                class: "ma-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" La clasificación aparece cuando la liga está generada. ")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(TablaClasificacionLiga, { filas: clasificacion.value }, null, 8, ["filas"]),
                                (!ligaCerrada.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        variant: "tonal",
                                        onClick: pedirGuardar
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Cerrar liga y guardar resultados ")
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : (_openBlock(), _createBlock(_component_v_alert, {
                                      key: 1,
                                      type: "success",
                                      variant: "tonal",
                                      density: "compact",
                                      class: "my-3 text-left"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Liga cerrada: los resultados ya están guardados. ")
                                      ]),
                                      _: 1
                                    }))
                              ], 64))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tabs_window_item, { value: "listas" }, {
                      default: _withCtx(() => [
                        _createVNode(TabMostrarListas, { torneo: torneo.value }, null, 8, ["torneo"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: showConfirmar.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showConfirmar).value = $event)),
        "max-width": "420"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-wrap" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(confirmar.value.titulo), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(confirmar.value.texto), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "grey",
                    variant: "text",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showConfirmar.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancelar ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: confirmar.value.color,
                    variant: "tonal",
                    onClick: ejecutarConfirmado
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Confirmar ")
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: isGuardando.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isGuardando).value = $event)),
        persistent: "",
        width: "200"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "pa-6 d-flex justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "60"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ModalSuccess, {
        isVisible: showSuccess.value,
        message: mensaje.value,
        "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = $event))
      }, null, 8, ["isVisible", "message"]),
      _createVNode(ModalError, {
        isVisible: showError.value,
        message: mensaje.value,
        "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showError.value = $event))
      }, null, 8, ["isVisible", "message"])
    ]),
    _: 1
  }))
}
}

})